/** Group support slots by local calendar day — mirrors zenpost-frontend BookStep. */

export interface SupportSlot {
  id: string;
  starts_at: string;
  ends_at: string;
}

export interface SupportSlotDay {
  key: string;
  label: string;
  slots: SupportSlot[];
}

export function groupSupportSlotsByDay(
  slots: readonly SupportSlot[],
  locale: string,
): SupportSlotDay[] {
  const dayLabel = new Intl.DateTimeFormat(locale, {
    weekday: "long",
    day: "numeric",
    month: "short",
  });

  const days = new Map<string, SupportSlotDay>();
  for (const slot of slots) {
    const date = new Date(slot.starts_at);
    if (Number.isNaN(date.getTime())) continue;
    const key = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    const existing = days.get(key);
    if (existing) {
      existing.slots.push(slot);
    } else {
      days.set(key, { key, label: dayLabel.format(date), slots: [slot] });
    }
  }
  return [...days.values()];
}

export function formatSlotClock(iso: string, locale: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return new Intl.DateTimeFormat(locale, { hour: "2-digit", minute: "2-digit" }).format(date);
}

export function formatSupportSlotTime(iso: string, locale: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return new Intl.DateTimeFormat(locale, {
    weekday: "long",
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
}
